import React from 'react';

import { btnGhost, Card, labelClass } from '../ui';
import { fieldClass, TClassForm, TIME_ZONES, TSetField } from './shared';

type Props = {
  form: TClassForm;
  set: TSetField;
  isNew: boolean;
  extraDates: { start: string; end: string }[];
  setExtraDates: React.Dispatch<
    React.SetStateAction<{ start: string; end: string }[]>
  >;
  addSession: () => void;
};

/** Start, end and time zone; on a new class, extra sessions make it a series. */
const DatesSection: React.FC<Props> = ({
  form,
  set,
  isNew,
  extraDates,
  setExtraDates,
  addSession,
}) => (
  <Card title="Class Date(s) and Time(s)">
    <div className="grid grid-cols-1 gap-4 p-5 md:grid-cols-3">
      <div>
        <label className={labelClass}>Course start date/time</label>
        <input
          type="datetime-local"
          className={fieldClass}
          value={form.start}
          onChange={(e) => set('start')(e.target.value)}
        />
      </div>
      <div>
        <label className={labelClass}>Course end date/time</label>
        <input
          type="datetime-local"
          className={fieldClass}
          value={form.end}
          onChange={(e) => set('end')(e.target.value)}
        />
      </div>
      <div>
        <label className={labelClass}>Time zone</label>
        <select
          className={fieldClass}
          value={form.timeZone}
          onChange={(e) => set('timeZone')(e.target.value)}
        >
          {TIME_ZONES.map((t) => (
            <option key={t}>{t}</option>
          ))}
        </select>
      </div>
      {isNew && (
        <div className="md:col-span-3">
          {extraDates.map((d, i) => (
            <div
              key={i}
              className="mb-2 grid grid-cols-1 items-end gap-3 md:grid-cols-3"
            >
              <div>
                <label className={labelClass}>Session {i + 2} start</label>
                <input
                  type="datetime-local"
                  className={fieldClass}
                  value={d.start}
                  onChange={(e) =>
                    setExtraDates((x) =>
                      x.map((row, j) =>
                        j === i ? { ...row, start: e.target.value } : row,
                      ),
                    )
                  }
                />
              </div>
              <div>
                <label className={labelClass}>Session {i + 2} end</label>
                <input
                  type="datetime-local"
                  className={fieldClass}
                  value={d.end}
                  onChange={(e) =>
                    setExtraDates((x) =>
                      x.map((row, j) =>
                        j === i ? { ...row, end: e.target.value } : row,
                      ),
                    )
                  }
                />
              </div>
              <button
                type="button"
                className={`${btnGhost} justify-self-start`}
                onClick={() =>
                  setExtraDates((x) => x.filter((_, j) => j !== i))
                }
              >
                remove
              </button>
            </div>
          ))}
          <button type="button" className={btnGhost} onClick={addSession}>
            + Add a session (makes this a series)
          </button>
          {extraDates.length > 0 && (
            <div className="mt-1 text-xs text-gray-bold">
              {extraDates.length + 1} sessions will be created as one series,
              named “{form.name || 'Class'} · session i of{' '}
              {extraDates.length + 1}”.
            </div>
          )}
        </div>
      )}
    </div>
  </Card>
);

export default DatesSection;
